export default '1.18.1';


//////////////////
// WEBPACK FOOTER
// ../es/Version.js
// module id = kWgq
// module chunks = 73